import Reveal from './Reveal.jsx';
import { WHY_LIST, WHY_CARDS } from '../data/site.js';
import { scrollToId } from '../hooks/useActiveSection.js';

export default function WhyUs() {
  return (
    <section id="why-us" className="why-us">
      <div className="container">
        <div className="why-grid">
          <Reveal className="why-content">
            <div className="section-label">Why Kanaga</div>
            <h2 className="section-title">
              Where Trust Meets<br />Expert Care
            </h2>
            <p className="why-desc">
              We are more than just a dental clinic — we are a place where your smile is genuinely
              cared for. From the moment you step in, you'll notice the difference that real
              compassion and expertise make.
            </p>
            <ul className="why-list">
              {WHY_LIST.map((item) => (
                <li key={item}>
                  <span className="wl-dot" />
                  {item}
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              className="btn btn-primary"
              style={{ marginTop: '2rem' }}
              onClick={(e) => {
                e.preventDefault();
                scrollToId('contact');
              }}
            >
              Get In Touch
            </a>
          </Reveal>

          <Reveal className="why-cards" delay={80}>
            {WHY_CARDS.map((c) => (
              <div className="why-card" key={c.title}>
                <div className="wc-emoji">{c.emoji}</div>
                <h4>{c.title}</h4>
                <p>{c.text}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
